<template>
    <div>
        <div class="mb-3">


            <div class="col-xl-6 col-lg-12">
                <div class="form-group form-row">
                    <label class="col-xl-3 col-lg-3 col-form-label fs-12 pt-12"> {{i18n('Check ticket')}}</label>
                    <div class="col-xl-8 col-lg-4">
                        <datepicker
                                v-model="trip_date"
                                :inputClass="'form-control base_input'"
                                :bootstrap-styling="true"
                                :calendar-button="true"
                                calendar-button-icon="mdi mdi-calendar"
                                format="dd.MM.yyyy" class="m_datepicker">
                        </datepicker>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12">
                <div class="form-group form-row">
                    <label class="col-xl-3 col-lg-3 col-form-label fs-12 pt-12">{{i18n('Destination')}}: </label>
                    <div class="col-xl-8 col-lg-4">
                        <model-list-select :list="trips"
                                           v-model="trip_id"
                                           option-value="id"
                                           :class="trip_id_required ? 'red-border': ''"
                                           option-text="name" class="w-50"
                                           @click="removeErrorMessage"
                                           :placeholder="i18n('Select stations')">
                        </model-list-select>
                    </div>
                    <a href="#" class="btn">
                        <i class="mdi mdi-close ml-1" v-if="trip_id !== null" @click.prevent="trip_id = null"></i>
                    </a>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12">
                <div class="form-group form-row">
                    <label class="col-xl-3 col-lg-3 col-form-label fs-12 pt-12">{{i18n('Ticket Details')}}</label>
                    <div class="col-xl-8 col-lg-4">
                        <input type="text" class="form-control base_input" :placeholder="i18n('Full name')"
                               v-model="full_name" :class="full_name_required ? 'is-invalid' : ''"
                               @click="removeErrorMessage"/>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-12">
                <div class="form-group form-row">
                    <a class="col-xl-3 col-lg-3 col-form-label fs-12 pt-12"
                       data-toggle="collapse" href="#collapseExample" role="button"
                       aria-expanded="false" aria-controls="collapseExample">
                        {{i18n('Additional fields')}}

                    </a>
                    <div class="col-xl-8 col-lg-4">
                        <div class="collapse" id="collapseExample">
                            <div class="form-group">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Phone number')"
                                       v-model="phone"/>
                            </div>
                            <div class="fTriporm-group">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Passport number')"
                                       v-model="passport_number"/>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Номер места')"
                                       v-model="seat_number"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="mb-3">
            <div class="col-xl-12 col-lg-12" :class="[error_message.status ? 'active' : 'hidden']">
                <label class="col-xl-3 col-lg-3 col-form-label fs-12 pt-12"></label>
                <div class="col-xl-8 col-lg-4">
                    <label class="col-xl-10 col-lg-10 col-form-label fs-12 pt-12"><h2>{{error_message.message}}</h2>
                    </label>
                </div>
            </div>

            <table class="table table-striped" v-show="success">
                <thead>
                <tr>
                    <th>{{i18n('Name')}}</th>
                    <th> {{i18n('Trip')}}</th>
                    <th>{{i18n('Place')}}</th>
                    <th>{{i18n('Number of ticket')}}</th>
                    <th>{{i18n('Passport')}}</th>
                    <th>{{i18n('Phone number')}}</th>
                    <th>{{i18n('Adress')}}</th>
                    <th>{{i18n('With baby')}}</th>
                    <th>{{i18n('Тип оплаты')}}</th> <!--alx-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, key) in results">
                    <td class="restoredPassenger"
                        @click="getTicket(item.ticket, item.with_child ? item.with_child.ticket_id : null)">
                        {{item.full_name}}
                    </td>
                    <td class="restoredPassenger"
                        @click="getTicket(item.ticket, item.with_child ? item.with_child.ticket_id : null)">
                        {{selected_trip}}
                    </td>
                    <td>{{item.seat}}</td>
                    <td>{{item.ticket}}</td>
                    <td>{{item.passport}}</td>
                    <td>{{item.phone}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.with_child ? 'Да' : 'Нет'}}</td>
                    <td>{{ paymentTypes(item) }}</td> <!--alx-->
                </tr>
                </tbody>
            </table>

            <div v-show="loading_states.list" class="text-center pt-3 pb-3">
                <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}...
            </div>

            <div class="col-xl-6 col-lg-8">
                <div>
                    <button type="button" class="btn base_btn solid_blue waves-effect waves-light"
                            @click="getTripByTicketId()"> {{i18n('Check ticket')}}
                    </button>
                </div>
            </div>

            <div v-show="printing_tickets.length > 0">
                <tickets :tickets="printing_tickets"></tickets>
            </div>

        </div>
    </div>
</template>

<script>
    import {ModelListSelect} from 'vue-search-select';
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import Tickets from './Tickets';

    export default {
        name: "TicketReturn",
        components: {
            ModelListSelect,
            Datepicker,
            Tickets,
        },
        data() {
            return {
                trip_date: this.$moment().format("DD.MM.YYYY"),
                full_name: '',
                phone: '',
                passport_number: '',
                seat_number: '',
                trip_id: null,
                selected_trip: null,
                trips: [],
                success: false,
                trip_id_required: false,
                full_name_required: false,
                printing_tickets: [],
                print_ticket_error_message: 'Поизошло ошибка!',
                results: [],
                error_message: {
                    status: false,
                    message: null,
                },
                loading_states: {
                    list: false,
                    button_show: true,
                    return_types_show: false,
                },
            }
        },
        methods: {
            getTripByTicketId() {
                this.printing_tickets = [];
                this.loading_states.list = true;
                this.success = false;
                this.trip_id_required = !this.trip_id;
                this.full_name_required = !this.full_name;
                if (this.trip_id_required === true || this.full_name_required === true) {
                    this.loading_states.list = false;
                    return;
                }
                this.selected_trip = this.trips.find(item => item.id === this.trip_id).name;
                let postData = {};
                postData.trip_id = this.trip_id;
                postData.full_name = this.full_name;
                postData.phone = this.phone;
                postData.passport_number = this.passport_number;
                postData.seat_number = this.seat_number;
                this.$api.post('cashier.restore-ticket', postData)
                    .then(res => {
                        if (res.data.length <= 0) {
                            this.error_message.status = true;
                            this.loading_states.list = false;
                            this.error_message.message = 'Ничего не найдено по вашему запросу';
                        } else {
                            this.results = res.data;
                            this.success = true;
                            this.loading_states.list = false;
                        }
                    })
            },
            getTrips() {
                this.trips = [];
                let postData = {};
                postData.date = this.trip_date;
                this.$api.post('trips.get-daily-trip', postData).then(({data}) => {
                    for (let x in data) {
                        let value = [];
                        value['id'] = data[x].trip_id;
                        value['name'] = data[x].route_name + '  ' + data[x].trip_time;
                        this.trips.push(value);
                    }
                });
            },
            returnTicket() {
                this.printing_tickets = [];
                this.loading_states.list = true;
                let postData = {};
                postData.ticket_id = this.ticket_id;
                postData.return_type = this.return_type;
                postData.return_price = this.return_price;
                this.$api.post('return.return-ticket', postData).then(({data}) => {
                    if (data) {
                        this.$notify({
                            type: 'success',
                            group: 'success_notify',
                            title: this.i18n('Successfully!!!'),
                            text: this.i18n('Билет был успешно возвращен!')
                        });
                    }
                }).finally(() => {
                    this.loading_states.list = false;
                    this.ticket_id = null;
                    this.return_price = '';
                    this.return_type = '';
                });
            },
            removeErrorMessage() {
                this.error_message.status = false;
            },
            getTicket(ticket_id, child_ticket_id) {
                this.loading_states.list = true;
                this.printing_tickets = [];
                let tickets = {};
                tickets.ticket_id = ticket_id;
                tickets.child_ticket_id = child_ticket_id;
                this.$api.post('qr.get-tickets-by-id', tickets)
                    .then(res => {
                        if (res.tickets) {
                            this.printing_tickets = res.tickets;
                            this.loading_states.list = false;
                        }
                    });
            },
            onkeydown(e) {
                if(e.which === 13){
                    this.getTripByTicketId();
                }
            },
            //alx
            paymentTypes(passenger) {
                let type = passenger.payment_type;
                let cashier_id = passenger.created_by;
                //alx if there is no Cashier (cashier_id is null) then show payment_type as ONLINE...  TODO: use payment orign Payme, Paynet, etc...
                if (cashier_id === null) {
                    return 'Онлайн';
                }
                switch (type) {
                    case 1:
                        return 'Нал.';
                    case 2:
                        return 'Терм.';
                }
                return '-';
            },
        },
        computed: {},
        watch: {
            trip_date: function () {
                this.getTrips();
            },
        },
        created() {
            this.trip_date = this.$moment().format("YYYY-MM-DD");
            window.addEventListener('keydown', this.onkeydown);
        },
    }
</script>
<style>
    .input-group-text {
        padding: 0.275rem 0.75rem !important;
    }
</style>
<style scoped>
    .active {
        display: flex;
    }
    .hidden {
        display: none;
    }
    .r-b-active {
        display: unset;
    }
    .ui.fluid.dropdown {
        width: 100% !important;
    }
    .red-border {
        border: 1px solid red !important;
    }
    .restoredPassenger {
        text-decoration: underline;
        cursor: pointer;
        font-style: italic;
    }

</style>
